module.exports = __webpack_public_path__ + "img/control-4.0a994ae.jpg";